import {useMutation, useQueryClient} from 'react-query';
import {AxiosError} from 'axios';
import {toast} from 'react-toastify';
import postBasket from './postBasket';

export interface IPostBasketPayload {
  advertisement_id: string;
  quantity: number;
}

const usePostBasket = (handleAfterSuccess?: () => void) => {
  const queryClient = useQueryClient();
  const {isLoading, mutate, isSuccess} = useMutation({
    mutationFn: (payload: IPostBasketPayload) => {
      return postBasket(payload);
    },
    onSuccess: data => {
      handleAfterSuccess && handleAfterSuccess();
      queryClient.invalidateQueries(['get-basket']);
      queryClient.invalidateQueries(['get-basket-count']);
      queryClient.invalidateQueries(['get-cart-detail-list']);
      queryClient.invalidateQueries(['get-shop-advertisements-by-input']);
      queryClient.invalidateQueries(['get-subBrand-advertisement-list']);
    },
    onError: (error: AxiosError<IAxiosErr>) => {
      toast.error(
        error?.response?.data?.message ||
          'مشکلی پیش آمده ،لطفا در زمان دیگری مراجعه فرمایید',
      );
    },
  });

  return {isLoading, mutate, isSuccess};
};

export default usePostBasket;
